import $ from 'jquery';
import FileUploadWithPreview from 'file-upload-with-preview';
import Axios from 'axios';
import Vue from 'vue';
import Apex from 'apexcharts/dist/apexcharts.min';
import Cookies from 'js-cookie';

window.$ = window.jQuery = $;
window.Cookies = Cookies;
window.Axios = Axios;
const csrfToken = document.head.querySelector('meta[name="csrf-token"]');

if (csrfToken) {
    Axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken.content;
}

Axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.FileUploadWithPreview = FileUploadWithPreview;
window.Apex = Apex;


require('jquery-ui-dist/jquery-ui.min');
require('jquery-slimscroll');
require('jquery.maskedinput/src/jquery.maskedinput');

require('bootstrap');
require('bootstrap-datepicker');
require('bootstrap-datepicker/dist/locales/bootstrap-datepicker.ru.min');

require('bootstrap-select/dist/js/bootstrap-select.min');
require('bootstrap-select/dist/js/i18n/defaults-ru_RU.min');
require('datatables.net/js/jquery.dataTables.min');
require('datatables.net-bs4/js/dataTables.bootstrap4.min');
require('datatables.net-responsive-bs4/js/responsive.bootstrap4.min');
require('datatables.net-fixedheader-bs4/js/fixedHeader.bootstrap4.min');

require('./tag-it.min');
require('jautocalc/dist/jautocalc.min');

require('dhtmlx-scheduler/codebase/dhtmlxscheduler');
require('dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_limit');
require('dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_tooltip');
require('dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_minical');
require('dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_editors');
require('dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_container_autoresize');
require('dhtmlx-scheduler/codebase/locale/locale_ru');
require('./timeline.min');
require('nvd3/build/nv.d3.min');
require('x-editable-bs4/dist/bootstrap4-editable/js/bootstrap-editable.min');

//require('@fortawesome/fontawesome-free/js/all.min');

window.moment = require('moment');
window.moment.locale('ru');
require('bootstrap-daterangepicker');

require('./color-admin');
require('./income-modals');
require('./income-bank-import');
require('./stock-drilldowns');
const initStockBalanceTable = require('./stock-balance-table');
window.initStockBalanceTable = initStockBalanceTable;
require('./stock-balances');
require('./stock-balance-print-options');
require('./stock-receipts');
require('./stock-transactions');
require('./stock-items');
require('./stock-reports');
require('./stock-action-form');
require('./stock-transfer-units');
require('./stock-action-units');
require('./property-stock-inventory');
require('./stock-item-show');

window.Vue = Vue;
window.events = new Vue();

Vue.component(
    'search-modal',
    require('../views/client/vue-components/search-modal').default
);

Vue.component(
    'property-picker',
    require('../views/client/vue-components/property-picker.vue').default
);

Vue.component(
    'stock-addition-lines',
    require('../views/client/vue-components/stock-addition-lines.vue').default
);
Vue.component('stock-addition-payments', require('../views/client/vue-components/stock-addition-payments.vue').default);

window.renderAqChart = (selector, data, colors) => {
    const sorted = data.slice().sort((a, b) => b.clients - a.clients);

    (new Apex(
        document.querySelector(selector), {
            chart: {
                height: 250,
                type: 'donut',
            },
            legend: {
                show: false,
            },
            dataLabels: {
                enabled: true,
                formatter: function (_, opts) {
                    const series = (opts.w.config.series || []).map(Number);
                    const seriesSum = series.reduce(function (a, b) { return a + b; }, 0);
                    return seriesSum ? Math.round(series[opts.seriesIndex] / seriesSum * 100) + '%' : '0%';
                },
                dropShadow: {
                    enabled: false,
                }
            },
            colors: colors,
            series: sorted.map(item => item.clients),
            labels: sorted.map(item => item.name),
        }
    )).render();
};

window.renderBarChart = (selector, data) => {
    const hasPlannedExpenses = data.some(item => Object.prototype.hasOwnProperty.call(item, 'planned_expense'));
    const series = hasPlannedExpenses
        ? [
            { name: 'Доход', data: data.map(item => item.income)},
            { name: 'Фактический расход', data: data.map(item => item.paid_expense)},
            { name: 'Плановый расход', data: data.map(item => item.planned_expense)},
            { name: 'Итого', data: data.map(item => item.sum)},
        ]
        : [
            { name: 'Доход', data: data.map(item => item.income)},
            { name: 'Расход', data: data.map(item => item.expense)},
            { name: 'Итого', data: data.map(item => item.sum)},
        ];

    (new Apex(
        document.querySelector(selector), {
            chart: { height: 350, type: 'bar' },
            plotOptions: { bar: { horizontal: false, borderRadius: 3, columnWidth: '65%', endingShape: 'rounded' } },
            dataLabels: { enabled: false },
            stroke: { show: true, width: 2, colors: ['transparent'] },
            colors: hasPlannedExpenses
                ? ["rgba(90,174,88,0.7)","rgba(255,54,1,0.7)","rgba(255,193,7,0.8)","rgba(5,172,172,0.7)"]
                : ["rgba(90,174,88,0.7)","rgba(255,54,1,0.7)","rgba(5,172,172,0.7)"],
            series,
            xaxis: {
                categories: data.map(item => item.name),
                labels: {
                    style: {
                        colors: "rgba(255, 255, 255, 0.65)",
                    },
                },
            },
            yaxis: {
                title: {
                    text: 'Руб.',
                    style: {
                        color: "rgba(255, 255, 255, 0.65)",
                    },
                },
                labels: {
                    style: {
                        colors: "rgba(255, 255, 255, 0.65)",
                    },
                    formatter: function (value) {
                        var val = Math.abs(value);

                        if (val >= 10 ** 3 && val < 10 ** 6) {
                            val = (val / 1000).toFixed(0) + ' тыс'
                        } else if (val >= 10 ** 6) {
                            val = (val / 1000000).toFixed(2) + ' млн'
                        } else {
                            val = val;
                        }

                        return val
                    }
                },
            },
            fill: { opacity: 1 },
            legend: {
                labels: {
                    colors: ["rgba(255, 255, 255, 0.65)"],
                    useSeriesColors: false
                },
            },
            tooltip: {
                theme: "dark",
            }
        }
    )).render();
};

window.initCharts = ($root) => {
    $root.find('[data-chart-type="bar"]').each(function () {
        if (typeof Apex !== 'undefined' && typeof Apex.exec === 'function') {
            Apex.exec(this.id, 'destroy');
        }
        renderBarChart('#' + this.id, JSON.parse($(this).attr('data-chart-config')));
    });

    $root.find('[data-chart-type="pie"]').each(function () {
        if (typeof Apex !== 'undefined' && typeof Apex.exec === 'function') {
            Apex.exec(this.id, 'destroy');
        }
        const colorsAttr = $(this).attr('data-chart-colors');
        const colors = colorsAttr ? JSON.parse(colorsAttr) : [];
        renderAqChart('#' + this.id, JSON.parse($(this).attr('data-chart-config')), colors);
    });
};

const app = new Vue({
    el: '#page-container'
});
